import { ErrorMessage, Field } from "formik";
import * as React from "react";

interface FormikSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  name: string;
  options: { value: string; label: string }[];
}

interface FormikFieldProps {
  field: React.SelectHTMLAttributes<HTMLSelectElement>;
}

const FormikSelect: React.FC<FormikSelectProps> = (props) => {
  return (
    <React.Fragment>
      <Field {...props} as="select">
        {({ field }: FormikFieldProps) => {
          return (
            <div>
              <label>{props.label ? `${props.label}${props.required ? " *" : ""}` : ""}</label>
              <select
                className={"form-control form-control-lg"}
                {...field}
                {...props}
                style={{ outline: "none", border: "1px solid #B6B6B6", width: "100%", height: "40px", borderRadius: "8px", padding: "10px 15px", ...props.style }}
              >
                {props.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          );
        }}
      </Field>
      <ErrorMessage className="text-danger mt-1" component="span" name={props.name ?? ""} />
    </React.Fragment>
  );
};

export default FormikSelect;
